<!-- Editar Productos Desembolso -->

<p-panel header="{{ 'PRODUCTO.LBL_DESEMBOLSO' | translate}}">

  <form [formGroup]="formulario" (ngSubmit)="guardar()" id="formProductoDesembolso" name="formProductoDesembolso">
    <!-- 1 -->
    <div class="grid">
      <div class="lg:col-6 col-12 col-nopad">
        <div class="grid">
          <div class="col-12">
            <h2 class="">{{ 'PRODUCTO.LBL_RANGOMONTOAPROBADO' | translate }}</h2>
          </div>
          <div class="col-6">
            <div class="div-form">
              <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINIMA' | translate }}: </strong></label>
              <input type="tel" pInputText id="rangoMontoAprobadoMinimo" name="rangoMontoAprobadoMinimo"
                     formControlName="rangoMontoAprobadoMinimo" numero-decimal-reactive [entero]="7" [decimales]="6" [maxLength]="14">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoMontoAprobadoMinimo.invalid">
                {{ 'PRODUCTO.LBL_MINIMA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && rangoInvalido">
                {{ 'PRODUCTODESEMBOLSO.MSG_RNGOMONTOAPRMINMAXEXISTE' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="div-form">
              <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MAXIMA' | translate }}: </strong></label>
              <input type="tel" pInputText id="rangoMontoAprobadoMaximo" name="rangoMontoAprobadoMaximo"
                     formControlName="rangoMontoAprobadoMaximo" numero-decimal-reactive [entero]="7" [decimales]="6" [maxLength]="14">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoMontoAprobadoMaximo.invalid">
                {{ 'PRODUCTO.LBL_MAXIMA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && !rangoMontoAprobadoValido">
                {{ 'PRODUCTO.MSG_ERRORRANGO' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lg:col-6 col-12 col-nopad">
        <div class="grid">
          <div class="col-12">
            <h2 class="">{{ 'PRODUCTO.LBL_RANGOPLAZOAPROBADO' | translate }}</h2>
          </div>
          <div class="col-6">
            <div class="div-form">
              <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINDIA' | translate }}: </strong></label>
              <input type="tel" pInputText id="rangoPlazoAprobadoMinimo" name="rangoPlazoAprobadoMinimo" autocomplete=""
                     formControlName="rangoPlazoAprobadoMinimo" numero-decimal-reactive [entero]="3" [decimales]="6" [maxLength]="10">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoPlazoAprobadoMinimo.invalid">
                {{ 'PRODUCTO.LBL_MINDIA' | translate }} {{'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && !rangoPlazoAprobadoValido">
                {{ 'PRODUCTO.MSG_ERRORRANGO' | translate }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="div-form">
              <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MAXDIA' | translate }}: </strong></label>
              <input type="tel" pInputText id="rangoPlazoAprobadoMaximo" name="rangoPlazoAprobadoMaximo" autocomplete=""
                     formControlName="rangoPlazoAprobadoMaximo" numero-decimal-reactive [entero]="3" [decimales]="6" [maxLength]="10">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoPlazoAprobadoMaximo.invalid">
                {{ 'PRODUCTO.LBL_MAXDIA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && !rangoPlazoAprobadoValido">
                {{ 'PRODUCTO.MSG_ERRORRANGO' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 2 -->
    <div class="grid">

      <div class="col-12">
        <h2 class="">{{ 'PRODUCTO.LBL_RANGOTASAPRODUCTO' | translate }}</h2>
      </div>
      <div class="lg:col-3 col-6">
        <div class="div-form">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINIMA' | translate }}: </strong></label>
          <input type="tel" pInputText id="rangoTasaProductoMinimo" name="rangoTasaProductoMinimo" autocomplete=""
                 formControlName="rangoTasaProductoMinimo" numero-decimal-reactive [entero]="3" [decimales]="6"
                 [maxLength]="10">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoTasaProductoMinimo.invalid">
            {{ 'PRODUCTO.LBL_MINIMA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
      <div class="lg:col-3 col-6">
        <div class="div-form">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_ORDINARIA' | translate }}: </strong></label>
          <input type="tel" pInputText id="rangoTasaProductoOrdinario" name="rangoTasaProductoOrdinario" autocomplete=""
                 formControlName="rangoTasaProductoOrdinario" numero-decimal-reactive [entero]="3" [decimales]="6"
                 [maxLength]="10">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoTasaProductoOrdinario.invalid">
            {{ 'PRODUCTO.LBL_ORDINARIA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
      <div class="lg:col-6 col-12">
        <div class="div-form">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_LIMITEDIADESEMBOLSO' | translate }}: </strong></label>
          <input type="tel" pInputText id="limiteDiaDesembolso" name="limiteDiaDesembolso" autocomplete=""
                 formControlName="limiteDiaDesembolso" numero-entero-reactive [maxLength]="5">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.limiteDiaDesembolso.invalid">
            {{ 'PRODUCTO.LBL_LIMITEDIADESEMBOLSO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- 3 -->
    <div class="grid">

      <div class="lg:col-6 col-12 col-nopad">
        <div class="grid">
          <div class="col-12">
            <h2 class="">{{ 'PRODUCTO.LBL_CANTDESEMPARCIALES' | translate }}</h2>
          </div>
          <div class="col-6">
            <div class="div-form">
              <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINIMA' | translate }}: </strong></label>
              <input type="tel" pInputText id="minimoDiaCantidadDesembolsoParcial" name="minimoDiaCantidadDesembolsoParcial"
                     autocomplete=""
                     formControlName="minimoDiaCantidadDesembolsoParcial" numero-entero-reactive [maxLength]="5">
              <div class=" p-message p-messages-error p-corner-all" *ngIf="submitted && f.minimoDiaCantidadDesembolsoParcial.invalid">
                {{ 'PRODUCTO.LBL_MINIMA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && !diaCantidadDesembolsoParcialValido">
                {{ 'PRODUCTO.MSG_ERRORRANGO' | translate }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="div-form">
              <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MAXIMA' | translate }}: </strong></label>
              <input type="tel" pInputText id="maximoDiaCantidadDesembolsoParcial" name="maximoDiaCantidadDesembolsoParcial"
                     autocomplete=""
                     formControlName="maximoDiaCantidadDesembolsoParcial" numero-entero-reactive [maxLength]="5">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.maximoDiaCantidadDesembolsoParcial.invalid">
                {{ 'PRODUCTO.LBL_MAXIMA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && !diaCantidadDesembolsoParcialValido">
                {{ 'PRODUCTO.MSG_ERRORRANGO' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lg:col-6 col-12 col-nopad">
        <div class="grid">
          <div class="col-12">
            <h2 class="">{{ 'PRODUCTO.LBL_RANGOAMPLIARPLAZO' | translate }}</h2>
          </div>
          <div class="col-6">
            <div class="div-form">
              <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MINDIA' | translate }}: </strong></label>
              <input type="tel" pInputText id="rangoAmpliarPlazoMinimoDia" name="rangoAmpliarPlazoMinimoDia" autocomplete=""
                     formControlName="rangoAmpliarPlazoMinimoDia" numero-entero-reactive [maxLength]="5">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoAmpliarPlazoMinimoDia.invalid">
                {{ 'PRODUCTO.LBL_MINDIA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && !rangoAmpliarPlazoMaximoDia">
                {{ 'PRODUCTO.MSG_ERRORRANGO' | translate }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="div-form">
              <label class="control-label"><strong>{{ 'PRODUCTO.LBL_MAXDIA' | translate }}: </strong></label>
              <input type="tel" pInputText id="rangoAmpliarPlazoMaximoDia" name="rangoAmpliarPlazoMaximoDia" autocomplete=""
                     formControlName="rangoAmpliarPlazoMaximoDia" numero-entero-reactive [maxLength]="5">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoAmpliarPlazoMaximoDia.invalid">
                {{ 'PRODUCTO.LBL_MAXDIA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && !rangoAmpliarPlazoMaximoDia">
                {{ 'PRODUCTO.MSG_ERRORRANGO' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="grid">
      <div class="lg:col-3 col-6">
        <div class="div-form">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_VECESPLAZOAMPLIAR' | translate }}: </strong></label>
          <input type="tel" pInputText id="ampliarPlazo" name="ampliarPlazo" autocomplete="" formControlName="ampliarPlazo"
                 numero-decimal-reactive [entero]="3" [decimales]="6"
                 [maxLength]="10">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.ampliarPlazo.invalid">
            {{ 'PRODUCTO.LBL_VECESPLAZOAMPLIAR' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
      <div class="lg:col-3 col-6">
        <div class="div-form">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_DIASMAXMORACLIENTE' | translate }}: </strong></label>
          <input type="tel" pInputText id="diaMaximoMoraCliente" name="diaMaximoMoraCliente" autocomplete=""
                 formControlName="diaMaximoMoraCliente" numero-entero-reactive [maxLength]="5">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diaMaximoMoraCliente.invalid">
            {{ 'PRODUCTO.LBL_DIASMAXMORACLIENTE' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
      <div class="lg:col-6 col-12">
        <div class="div-form">
          <label class="control-label"><strong>{{ 'PRODUCTO.LBL_DIASMAXMORAPRODUCTO' | translate }}: </strong></label>
          <input type="tel" pInputText id="diaMaximoMoraProducto" name="diaMaximoMoraProducto" autocomplete=""
                 formControlName="diaMaximoMoraProducto" numero-entero-reactive [maxLength]="5">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.diaMaximoMoraProducto.invalid">
            {{ 'PRODUCTO.LBL_DIASMAXMORAPRODUCTO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <a (click)="regresar()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}" type="submit" pButton></button>
      </div>
    </div>
  </form>
  <p-confirmDialog #cd key="desembolso">
    <ng-template pTemplate="footer">
      <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
      <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
    </ng-template>
  </p-confirmDialog>

</p-panel>
